import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  viewChild,
  ViewChild,
} from '@angular/core';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { GrapesJsEditorBlocksService } from './grapesjs-editor-blocks.service';

declare var grapesjs: {
  init(options: any): object;
};
@Component({
  selector: 'ngx-grapes-grapesjs-editor',
  styleUrl: './grapesjs-editor.component.scss',
  templateUrl: './grapesjs-editor.component.html',
  imports: [CommonModule],
})
export class NgxGrapesJsEditorComponent implements OnInit {
  //#region properties
  @ViewChild('editorContainer', { static: true }) editorContainer!: ElementRef;
  @Input() pageHtml;
  @Output() htmlChanged: EventEmitter<string> = new EventEmitter();
  @Output() cssChanged: EventEmitter<string> = new EventEmitter();

  isShowScrollBtns = signal<boolean>(false);
  rowHeight: number;
  readonly scroller = viewChild<ElementRef>('scroller');
  scrollInterval: any;
  editor: any;

  appState = inject(AppStateService);
  grapesJsEditorBlocksService = inject(GrapesJsEditorBlocksService);

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.checkOverflow();
  }

  //#endregion

  ngOnInit() {
    this.setup();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageHtml'] && this.pageHtml) this.loadContent();
  }

  ngAfterViewChecked(): void {
    this.checkOverflow();
  }

  setup() {
    this.editor = grapesjs.init({
      container: this.editorContainer.nativeElement,
      plugins: ['grapesjs-preset-webpage', 'gjs-blocks-basic'],
      pluginsOpts: {
        'grapesjs-preset-webpage': {
          modalTitleImport: 'Import template',
        },
      },
    });

    this.addCustomBlocks();

    this.editor.on('change', () => {
      this.emitHtmlAndCss();
    });

    this.addCustomFonts();
  }

  //* Adds custom fonts to the typography sector in the Style Manager.
  addCustomFonts() {
    const typographySector = this.editor.StyleManager.getSector('typography');

    if (!typographySector) return;

    const fontFamilyProp = typographySector
      .getProperties()
      .find((prop) => prop.get('property') === 'font-family');

    if (fontFamilyProp) {
      const existingOptions = fontFamilyProp.get('options') || [];

      fontFamilyProp.set({
        options: [
          { value: 'Vazirmatn, sans-serif', name: 'Vazirmatn' },
          ...existingOptions,
        ],
        defaults: 'Vazirmatn, sans-serif', // مقدار پیش‌فرض
      });
    }
  }

  addCustomBlocks() {
    const blockManager = this.editor.BlockManager;
    this.grapesJsEditorBlocksService.addGrapesJsManualBlocks(blockManager);
  }

  emitHtmlAndCss() {
    const html = this.editor.getHtml();
    const css = this.editor.getCss();
    this.htmlChanged.emit(html);
    this.cssChanged.emit(css);
  }

  loadPreviousDesign(html: string) {
    if (!this.editor) {
      console.error('Editor is not initialized.');
      return;
    }

    this.editor.setComponents(html);
  }

  /**
   * Example Usage: Dynamically Load Content
   */
  loadContent() {
    const html = this.pageHtml;

    this.loadPreviousDesign(html);
  }

  //#region scroll

  // وقتی روی دکمه اسکرول نگه میداریم
  startScrollLeft() {
    this.scrollInterval = setInterval(() => {
      this.scrollLeft();
    }, 200); //  زمان اسکرول
  }

  startScrollRight() {
    this.scrollInterval = setInterval(() => {
      this.scrollRight();
    }, 200); //  زمان اسکرول
  }

  stopScroll() {
    clearInterval(this.scrollInterval);
  }

  scrollLeft() {
    this.scroller().nativeElement.scrollLeft -= 100; // تعداد پیکسل‌هایی که می‌خواهید به چپ اسکرول کند
  }

  scrollRight() {
    this.scroller().nativeElement.scrollLeft += 100; // تعداد پیکسل‌هایی که می‌خواهید به راست اسکرول کند
  }

  checkOverflow() {
    const scroller = this.scroller();
    if (scroller) {
      const scrollBar: HTMLElement = scroller.nativeElement;
      const curOverflow: boolean =
        scrollBar.scrollWidth > scrollBar.clientWidth;
      this.isShowScrollBtns.set(curOverflow);
    }
  }
  //#endregion
}
